module.exports = __webpack_public_path__ + "img/icon-lots-black.a433a0af.svg";